import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

export function PaymentMethodsError({
  onRetry,
  isRetrying,
}: {
  onRetry: () => void;
  isRetrying: boolean;
}) {
  const { t } = useTranslation("app");
  return (
    <div className="space-y-3 p-6">
      <p role="alert" className="text-destructive">
        {t("paymentMethodsScreen.loadError")}
      </p>
      <Button
        type="button"
        variant="outline"
        onClick={onRetry}
        disabled={isRetrying}
      >
        {t("actions.retry")}
      </Button>
    </div>
  );
}
